import { render, staticRenderFns } from "./ClientAISearch.vue?vue&type=template&id=40f6725f&scoped=true&"
import script from "./ClientAISearch.vue?vue&type=script&lang=js&"
export * from "./ClientAISearch.vue?vue&type=script&lang=js&"
import style0 from "./ClientAISearch.vue?vue&type=style&index=0&id=40f6725f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f6725f",
  null
  
)

export default component.exports